var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5514 3.73889L15.9576 2.33265C16.5678 1.72245 17.5572 1.72245 18.1674 2.33265C18.7775 2.94284 18.7775 3.93216 18.1674 4.54235L9.31849 13.3912C8.87792 13.8318 8.33453 14.1556 7.73741 14.3335L5.5 15L6.16648 12.7626C6.34435 12.1655 6.6682 11.6221 7.10877 11.1815L14.5514 3.73889ZM14.5514 3.73889L16.75 5.93749M15.5 11.6667V15.625C15.5 16.6605 14.6605 17.5 13.625 17.5H4.875C3.83947 17.5 3 16.6605 3 15.625V6.87499C3 5.83946 3.83947 4.99999 4.875 4.99999H8.83333",
    stroke: "#71717A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSquare);
export default __webpack_public_path__ + "static/media/pencil-square.2b9e2165e10a5c02fe8a39f201ea9302.svg";
export { ForwardRef as ReactComponent };